import channelSlice from "./channelSlice";

export default channelSlice.reducer;
export { default as channelSlice } from "./channelSlice";
